import { defineMessages } from 'react-intl';

export const messages: {
	searchResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchResults: {
		id: 'search-page.search-page-header.search-results',
		defaultMessage: 'Search results',
		description:
			'Header above the FPS results, shown next to the relocated "View all work items" CTA when the Jira NIN/FPS navigation experiment renders the button cohort from inside the search-page tree.',
	},
});
